// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://nzjyvoutgeltljazheej.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im56anl2b3V0Z2VsdGxqYXpoZWVqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY5MTk1MzIsImV4cCI6MjA3MjQ5NTUzMn0.q5fVU_UZ5gLs1GY3gYWqd2Cww-_gDYYQpg28n1v6uYo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});